import type { EnumToUnion } from 'types'

// 按钮类型
export enum PtButtonType {
  Filled = 'filled', // default
  Outlined = 'outlined',
  Ghost = 'ghost',
  Dash = 'dash',
  // Icon = 'icon', // icon模式，按钮间距特殊调整,
}
export type ButtonType = EnumToUnion<typeof PtButtonType>

// 按钮尺寸
export enum PtButtonSize {
  Big = 'big',
  Normal = 'normal', // default
  Small = 'small',
}
export type ButtonSize = EnumToUnion<typeof PtButtonSize>

// 按钮颜色类型
export enum PtButtonTheme {
  Brand = 'brand', // default
  Primary = 'primary',
  Danger = 'danger',
  Inverse = 'inverse',
  Secondary = 'secondary',
}
export type ButtonTheme = EnumToUnion<typeof PtButtonTheme>
